
import { classNames } from '../common/utils/utils';

interface CardProps {
  children: React.ReactNode;
  isFilters?: boolean;
}

const Card = ({ children, isFilters }: CardProps) => (
  <div
    className={classNames(
      isFilters ? 'rounded-t-xl' : 'rounded-xl',
      'overflow-visible bg-white flex flex-col divide-y divide-cool-gray-200 gap-0 shadow-md grow',
    )}
  >
    {children}
  </div>
);

export default Card;
